import React from 'react';
import { css } from 'aphrodite/no-important';
import styles from './VerticalSeparator.styles';

const VerticalSeparator = () => {
  return <div className={css(styles.base)} />;
};

export default VerticalSeparator;



// WEBPACK FOOTER //
// ./src/components/common/vseparator/VerticalSeparator.js